import React from 'react'
import './Basket.scss'
import { GlobalTypes, useGlobalState } from '../../contexts/global'
import { useCoursesState } from '../../contexts/courses'

const Basket: React.FC = () => {
  const { dispatch } = useGlobalState()
  const { state: coursesState } = useCoursesState()

  const coursesInBasket =
    coursesState.savedOnlineCourses.length +
    coursesState.savedPersonalCourses.length +
    coursesState.savedOnlineMockExamCourses.length +
    coursesState.savedPersonalTests.length

  return (
    <>
      <span
        onClick={() => dispatch({ type: GlobalTypes.ToggleModal, modal: 'ModalBasket' })}
        className="cursor-pointer"
      >
        <img
          className="w-[20px] h-[20px] lg:w-[25px] lg:h-[25px]"
          src="https://c.animaapp.com/mbyttqkuyMhIPB/img/mingcute-basket-line.svg"
        />
      </span>

      {coursesInBasket > 0 && <span className="basket-item-counter">{coursesInBasket}</span>}
    </>
  )
}

export default Basket
